import { Spinner } from '@jcom/common-components';
import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { isMobile, isTablet } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import { getAssetsList, setColorValues } from '../../Utils/AssetUtil';
import {
	getDetails,
	nextStep,
} from '../../Utils/HomeUtil';
import { commonUrl } from '../../Utils/StaticURLs';
import getStepsFromStoleMetaJson from '../../Utils/StepperUtil';
import {
	getAffiliatedId,
	getCustomerNumber,
	getOwnerId,
	getProfileGuid,
	getPubCatId,
	getPubCatProdId,
} from '../../Utils/Utils';
import {
	gaDesignerSubstep,
	gaPageLoad,
	gaSavaDesign,
} from '../../Utils/googleAnalytics';
import { getCustomerProductsById } from '../../services';
import MobileHeader from '../MobileHeader/MobileHeader';
import MobileNavigation from '../MobileNavigation/MobileNavigation';
import { EmptyZoneModal } from '../ZoneDesign/EmptyZoneModal';
import { InfoDesignModal } from '../modals/InfoDesignModal';
import '../modals/ModalContaint.css';
import { SaveDesignModal } from '../modals/SaveDesignModal';
import { ThankyouModal } from '../modals/ThankyouModal';
import Header from './../Header/Header';
import DesktopHome from './DesktopHome';

const pubCatProdId = getPubCatProdId();
const pubCatId = getPubCatId();

function Home(props) {
	const host = process.env.REACT_APP_JOSTENS_STOLE_BUILDER_HOST;
	const customerNumber = getCustomerNumber();
	const baseImgPath = process.env.REACT_APP_JOSTENS_CDN_HOST;
	const imgPrefix = process.env.REACT_APP_JOSTENS_CUSTOMER_IMAGE_PREFIX;

	const [selectedImage, setSelectedImage] = useState(false);
	const [stoleType, setStoleType] = useState('');
	const [affiliatedId, setAffiliatedId] = useState('');
	const [profileGuid, setProfileGuid] = useState('');
	const [snackBar, setSnackBar] = useState({
		open: false,
		variant: 'success',
		type: '',
		Body: '',
		Heading: '',
	});

	const [selectedTemplate, setSelectedTemplate] = useState(null);
	const [assetGroups, setAssetGroups] = useState();
	const [designGuid, setDesignGuid] = useState('');
	const [orderItemID, setOrderItemID] = useState('');
	const [stoleMeta, setStoleMeta] = useState();
	const [steps, setSteps] = useState([]);

	const [productId, setProductId] = useState('');
	const [currentStep, setCurrentStep] = useState(0);
	const [loading, setLoading] = useState(false);
	const [zoneAssets, setZoneAssets] = useState({
		schoolAsset: [],
		graphics: [],
	});
	const [colorList, setColorList] = useState();
	const [selectedStage, setSelectedStage] = useState('stole-design');
	const [estimatedPrice, setEstimatedPrice] = useState(0);
	const [buttonText, setButtonText] = useState('');
	const [selectedZone, setSelectedZone] = useState({});
	const [headerText, setHeaderText] = useState('');
	const [zoomImage, setZoomImage] = useState(false);
	const [stoleImagePath, setStoleImagePath] = useState({
		standard: '',
		enhanced: '',
		deluxe: '',
		premium: '',
	});
	const [stolePrice, setStolePrice] = useState({
		standard: '',
		enhanced: '',
		deluxe: '',
		premium: '',
	});
	const [modalShow, saveDesignFromModalShow] = useState(false);
	const [thankyomodalShow, setThankyomodalShow] = useState(false);
  	const [infoDesignModalShow, setinfoDesignModalShow] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [customerProducts, setCustomerProducts] = useState();
	const [selectDefault, setSelectDefault] = useState();
	const [visited, setVisited] = useState([]);
	const [stepClicked, setStepClicked] = useState(0);
	const [activeIndex, setActiveIndex] = useState(0);
	const [altImage, setAltImage] = useState('');
	const [previewImage, setPreviewImage] = useState('');
	const [brandingTab, setBrandingTab] = useState(0);
	const [substemNameBranding, setsubstemNameBranding] = useState();
  	const [substemNameZone, setsubstemNameZone] = useState();
	const [fontList, setFontList] = useState();
	const [zoneImagePath, setZoneImagePath] = useState({});
	const [zoneTextStatus, setZoneTextStaus] = useState({});
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const location = useLocation();

	const getCustomerProducts = async () => {
		const { data } = await getCustomerProductsById(customerNumber)
		setLoading(false);
		const products = {};
		const receivedData = data || [];
		receivedData.forEach((product) => {
			const variant = product && product.productVariant;
			variant && (products[variant] = product);
		});
		setCustomerProducts(products);
		gaPageLoad(products);
	}

	useEffect(() => {
		setZoneImagePath({})
		setLoading(true);
		getCustomerProducts();
	}, []);

	useEffect(() => {
		setStoleMeta(props.stoleMeta || {});
	}, [props.stoleMeta]);

	useEffect(() => {
		customerProducts && Object.keys(customerProducts).length && getImages();
	}, [customerProducts]);

	useEffect(() => {
		if (stoleMeta !== null) {
			const steps = getStepsFromStoleMetaJson(stoleMeta, setStepClicked);
			setSteps(steps);
		}
	}, [stoleMeta]);

	const fetchProfileGuid = useCallback(() => {
		getProfileGuid().then((res) => setProfileGuid(res));
	}, []);

	useEffect(() => {
		fetchProfileGuid();
	}, [fetchProfileGuid]);

	useEffect(() => {
		let di =
			new URLSearchParams(location.search).get('di') ||
			new URLSearchParams(location.search).get('dg');
		setDesignGuid(di);
		setOrderItemID(new URLSearchParams(search).get('oii')); //make state variable and pass to addToCart
		if (di) {
			loadTemplatesWithMailFlow(di);
			setSelectDefault(false);
		} else {
			setSelectDefault(true);
		}
	}, []);

	useEffect(() => {
		if (selectDefault && customerProducts) {
			selectDefaultStole();
		}
	}, [selectDefault, customerProducts]);

	useEffect(() => {
		setAffiliatedId(getAffiliatedId());
		setLoading(true);
		axios
			.get(commonUrl + '/CollegeStoleAssetGroups.json')
			.then((res) => {
				setLoading(false);
				setAssetGroups(res.data.stoleAssetGroups);
			})
			.catch((err) => console.log(err));
	}, []);

	useEffect(() => {
		getAssetsList(setZoneAssets, customerNumber);
	}, [customerNumber]);

	useEffect(() => {
		if (selectedTemplate) {
			let price = selectedTemplate.product.basePrice;
			price =
				price +
					(selectedTemplate.designSettings &&
						selectedTemplate.designSettings.data &&
						selectedTemplate.designSettings.data.upchargeAmt) || 0;
			selectedTemplate.zones.forEach((zone) => {
				price = price + ((zone && zone.data && zone.data.upchargeAmt) || 0);
			});
			price !== estimatedPrice && setEstimatedPrice(price);
		}
		if (previewImage) {
			setActiveIndex(0);
			setPreviewImage('');
			setZoomImage(false);
		}
	}, [selectedTemplate]);

	useEffect(() => {
		if (
			selectedTemplate &&
			(!colorList || (colorList && colorList.length === 0))
		) {
			const colorsKey = selectedTemplate.designSettings['colorList'];
			setLoading(true);
			axios
				.get(commonUrl + '/' + colorsKey + '.json')
				.then((res) => {
					setLoading(false);
					setColorList(res.data && res.data.colors);
				})
				.catch((err) => setLoading(false));
		}
	}, [selectedTemplate]);

	useEffect(() => {
		getDetails(
			stoleMeta,
			selectedStage,
			selectedTemplate,
			setSelectedZone,
			setCurrentStep,
			setButtonText,
			setHeaderText,
			visited,
			setVisited
		);
		if (
			selectedTemplate &&
			Object.keys(selectedTemplate).length &&
			selectedStage !== 'review-order'
		) {
			setSelectedImage(true);
		}
	}, [selectedStage, stoleMeta]);

	useEffect(() => {
		if (selectedStage === 'school-branding') {
			if (brandingTab === 3) {
				setButtonText(
					stoleMeta &&
						stoleMeta.stepper &&
						stoleMeta.stepper.step3 &&
						stoleMeta.stepper.step3.toUpperCase()
				);
			} else {
				setButtonText(
					stoleMeta &&
						stoleMeta.configContainer &&
						stoleMeta.configContainer.footer &&
						stoleMeta.configContainer.footer.stoleBtn
				);
			}
		}
	}, [brandingTab, selectedStage]);

	const search = useLocation().search;
	const loadTemplatesWithMailFlow = (di) => {
		setLoading(true);
		axios
			.get(
				`${host}/consumerDesign?designGuid=${di}&customerNumber=${customerNumber}`
			)
			.then((res) => {
				setLoading(false);
				if (!!Object.keys(res.data).length) {
					setStoleType(res.data.variant);
					setSelectedTemplate(res.data.payload);
					let currentStage = res.data.payload.designSettings.data.currentStage;
					setSelectedStage(currentStage);
					if(currentStage === 'stole-design') setVisited([1]);
					if(currentStage === 'school-branding') setVisited([1,2]);
					if(currentStage === 'review-order') setVisited([1,2,3,4]);
					if(currentStage.includes('your-stole')) setVisited([1,2,3]);
					setSelectedImage(true);
					setProductId(res.data.productId);
					sessionStorage.setItem('stoleType', res.data.variant);
					let stole = res.data.variant;
					let product =
						res.data && res.data.payload && res.data.payload.product;
					let path =
						product &&
						product.mainImageRef &&
						product.mainImageRef.replace('.svg', '');
					let imagePath = path + '-alt-' + stole + '.jpg';
					setAltImage(imagePath);
				} else {
					setSelectDefault(true);
					setSnackBar({
						open: true,
						variant: 'danger',
						Heading:
							props.stoleMeta &&
							props.stoleMeta.fail &&
							props.stoleMeta.fail.wrongGuid,
					});
				}
			})
			.catch((err) => console.log(err));
	};

	const selectDefaultStole = () => {
		setStoleType('enhanced');
		setSelectedImage(true);
		getTemplateData('enhanced');
		sessionStorage.setItem('stoleType', 'enhanced');
	};
	const getImages = () => {
		let stnProdRefCode = customerProducts.standard.payload.product.prodRefcode;
		let enhProdRefCode = customerProducts.enhanced.payload.product.prodRefcode;
		let delProdRefCode = customerProducts.deluxe.payload.product.prodRefcode;
		let preProdRefCode = customerProducts.premium.payload.product.prodRefcode;

		let stnProdBasePrice = customerProducts.standard.payload.product.basePrice;
		let enhProdBasePrice = customerProducts.enhanced.payload.product.basePrice;
		let delProdBasePrice = customerProducts.deluxe.payload.product.basePrice;
		let preProdBasePrice = customerProducts.premium.payload.product.basePrice;

		setStolePrice({
			standard: stnProdBasePrice && stnProdBasePrice.toFixed(2),
			enhanced: enhProdBasePrice && enhProdBasePrice.toFixed(2),
			deluxe: delProdBasePrice && delProdBasePrice.toFixed(2),
			premium: preProdBasePrice && preProdBasePrice.toFixed(2),
		});

		setStoleImagePath({
			standard: `${baseImgPath}${imgPrefix}${customerNumber}/${stnProdRefCode}/${stnProdRefCode}-standard-md.jpg`,
			enhanced: `${baseImgPath}${imgPrefix}${customerNumber}/${delProdRefCode}/${delProdRefCode}-enhanced-md.jpg`,
			deluxe: `${baseImgPath}${imgPrefix}${customerNumber}/${enhProdRefCode}/${enhProdRefCode}-deluxe-md.jpg`,
			premium: `${baseImgPath}${imgPrefix}${customerNumber}/${preProdRefCode}/${preProdRefCode}-premium-md.jpg`,
		});
	};
	useEffect(() => {
		if (visited.includes(stepClicked)) {
			switch (stepClicked) {
				case 1:
					setSelectedStage('stole-design');
					break;
				case 2:
					setSelectedStage('school-branding');
					break;
				case 3:
					setSelectedStage('your-stole');
					break;
				case 4:
					setSelectedStage('review-order');
					break;
			}
			setStepClicked(0);
		}
	}, [stepClicked]);

	const selectImage = (event) => {
    setZoneImagePath({})
		setSelectedImage(true);
		setStoleType(event.target.alt);
		sessionStorage.setItem('stoleType', event.target.alt);
		getTemplateData(event.target.alt);
		setVisited([1]);
	};

	const getTemplateData = (stole) => {
		setSelectedTemplate(null);
		if (customerProducts && Object.keys(customerProducts).length) {
			customerProducts && setColorValues(customerProducts[stole].payload, colorList, setSelectedTemplate);
			setProductId(customerProducts[stole].productId);
			let product =
				customerProducts[stole] &&
				customerProducts[stole].payload &&
				customerProducts[stole].payload.product;
			let path =
				product &&
				product.mainImageRef &&
				product.mainImageRef.replace('.svg', '');
			let imagePath = path + '-alt-' + stole + '.jpg';
			setAltImage(imagePath);
		}
	};
	useEffect(() => {
		selectedTemplate && setColorValues(selectedTemplate, colorList, setSelectedTemplate);
	}, [colorList]);
	const getSaveDesignPayload = () => {
		if (selectedTemplate) {
			let updatedData = { ...selectedTemplate };
			updatedData.pubCatId = pubCatId;
			updatedData.pubCatProdId = pubCatProdId;
			updatedData.customerNumber = customerNumber;
			updatedData.designGuid = '';
			updatedData.designSettings.data.currentStage = selectedStage;
			let completePayload = {
				status: 'Save',
				payload: { ...updatedData },
				customerNumber: customerNumber,
				profileGuid: profileGuid,
				ownerId: getOwnerId(),
				variant: stoleType,
				productId: productId,
			};
			return completePayload;
		}
		return null;
	};

	const getRoPayload = (val, stage) => {
		val && setSelectedTemplate(val);
		stage && setSelectedStage(stage);
	};

	// SAVE & EMAIL DESIGN  starts
	const saveDesign = (email, firstname, lastname, specialoffers) => {
		let completePayload = getSaveDesignPayload();
		completePayload.emailId = email;
		completePayload.firstName = firstname;
		completePayload.lastName = lastname;
		completePayload.specialOffers = specialoffers;
		let savedesignformdataContent = {
			email: email,
			firstname: firstname,
			lastname: lastname,
			specialoffers: specialoffers,
		};
		localStorage.setItem(
			'savedesignformdata',
			JSON.stringify(savedesignformdataContent)
		);
		saveDesignFromModalShow(false);
		setLoading(true);
		axios
			.post(`${host}/saveConsumerDesign`, completePayload)
			.then((res) => {
				setLoading(false);
				setThankyomodalShow(true);
			})
			.catch((err) => {
				setLoading(false);
				setSnackBar({
					open: true,
					variant: 'danger',
					Body: stoleMeta.fail.because,
					Heading: stoleMeta.saveDesignPopUp.title,
				});
			});
		gaSavaDesign(currentStep, selectedStage, selectedTemplate, completePayload);
	};
	// SAVE & EMAIL DESIGN ends
	const stolePreview = (callBack) => {
		let previewcompletePayload = getSaveDesignPayload();
		setLoading(true);
		axios
			.post(`${host}/stolePreview`, previewcompletePayload)
			.then((res) => {
				setLoading(false);
				setPreviewImage(res.data.message);
        setActiveIndex(2);
        callBack && callBack(true)
			})
			.catch((err) => {
				console.log(err)
				setLoading(false);
				setSnackBar({
					open: true,
					variant: 'danger',
					Body: stoleMeta.preview.failMsg,
					Heading: stoleMeta.preview.title,
				});
			});
	};

	const next = () => {
		if (
			selectedStage !== 'school-branding' ||
			(selectedStage === 'school-branding' && brandingTab === 3)
		) {
			let currentZone = selectedStage.includes('your-stole') ? selectedStage.substr(11) : '';
			let isTextConfirmed = currentZone ? zoneTextStatus[currentZone] === undefined ? true: zoneTextStatus[currentZone] : true;
			if(!isTextConfirmed){
				setShowConfirmModal(true);
				setTimeout(() => {
					setShowConfirmModal(false)
				}, 3000);
			}else{
				if(selectedStage === 'stole-design') {
					setBrandingTab(0);
				}
				nextStep(
					selectedTemplate,
					selectedStage,
					setSnackBar,
					profileGuid,
					setSelectedStage,
					setShowModal,
					designGuid,
					orderItemID,
					productId,
					setLoading,
					stoleMeta,
					currentStep,
					substemNameBranding,
					substemNameZone,
					brandingTab,
					setinfoDesignModalShow
				);
			}
		} else {
			setBrandingTab(brandingTab + 1);
			gaDesignerSubstep(
				currentStep,
				selectedStage,
				setSelectedStage,
				selectedTemplate,
				substemNameBranding,
				brandingTab
			);
		}
	};

	const updateSelectedTemplate = (data) => {
		let template = { ...selectedTemplate };
		let threadWebColor =
			template &&
			template.designSettings &&
			template.designSettings.data &&
			template.designSettings.data.threadWebColor;
		let newThreadWebColor = data && data.data && data.data.threadWebColor;
		if (threadWebColor !== newThreadWebColor) {
			let zones = template.zones;
			zones &&
				zones.forEach((zone) => {
					zone.data &&
						zone.data.designImageUrl &&
						(zone.data.designImageUrl = zone.data.designImageUrl.replace(
							'-' + threadWebColor,
							'-' + newThreadWebColor
						));
				});
			template.zones = [...zones];
		}
		template.designSettings = { ...data };
		setSelectedTemplate(template);
	};
	const updateZoneData = (data, code) => {
		let template = { ...selectedTemplate };
		template.zones = template && template.zones && template.zones.map((zone) =>
			zone.zoneCode === code ? data : zone
		);
		setSelectedTemplate(template);
	};

	const checkBoxValue = (val) => {
		selectedStage === 'review-order' && setSelectedImage(val);
	};

	const getBrandingTabName = (tabname) => {
		setsubstemNameBranding(tabname);
	};
	const getZoneTabName = (tabname) => {
		setsubstemNameZone(tabname);
  };
  
  const getFontList = () =>{
    const fontKey = selectedTemplate && selectedTemplate.designSettings["fontList"];
        setLoading(true);
        axios
          .get(commonUrl + "/" + fontKey + ".json")
          .then((res) => {
            setLoading(false);
            setFontList(res.data && res.data.Fonts);
          })
          .catch((err) => setLoading(false));
  }

	return (
		<>
			<EmptyZoneModal
				showModal={showModal}
				setShowModal={setShowModal}
				missingDecorAlert={stoleMeta && stoleMeta.missingDecorAlert}
				selectedZone={selectedZone}
				selectedTemplate={selectedTemplate}
				selectedStage={selectedStage}
				setSelectedStage={setSelectedStage}
				substemNameZone={substemNameZone}
				images={
					(stoleMeta && stoleMeta.image && stoleMeta.image.emptyZone) || {}
				}
			/>
			{stoleMeta !== null ? (
        (isMobile && !isTablet) ? 
        <MobileHeader
					data={(stoleMeta && stoleMeta.header) || {}}
					estimatedPrice={estimatedPrice}
					selectedStage={selectedStage}
					selectedTemplate={selectedTemplate}
					saveDesignFromModalShow={saveDesignFromModalShow}
					fail={(stoleMeta && stoleMeta.fail) || {}}
					exitStoleAlert={(stoleMeta && stoleMeta.exitStoleAlert) || {}}
					startOver={(stoleMeta && stoleMeta.startOverAlert) || {}}
				/> :
				<Header
					data={(stoleMeta && stoleMeta.header) || {}}
					exitStoleAlert={(stoleMeta && stoleMeta.exitStoleAlert) || {}}
					estimatedPrice={estimatedPrice}
					link={(stoleMeta && stoleMeta.link) || {}}
					selectedStage={selectedStage}
					selectedTemplate={selectedTemplate}
					saveDesignFromModalShow={saveDesignFromModalShow}
					startOver={(stoleMeta && stoleMeta.startOverAlert) || {}}
					fail={(stoleMeta && stoleMeta.fail) || {}}
				/>
			) : null}

			<Modal
				show={snackBar.open}
				aria-labelledby='contained-modal-title-vcenter'
				dialogClassName='modal-md modal-box'
				className='thankyou-modal'
				backdrop='static'
				keyboard={false}>
				<Modal.Header
					closeButton
					className='modal-header border-0'
					onClick={() => setSnackBar({ open: false })}>
					<h4> {snackBar.Heading}</h4>
				</Modal.Header>
				<Modal.Body>
					<p>{snackBar.Body}</p>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
      {loading && <Spinner />}
      {(isMobile && !isTablet) ? 
        <MobileNavigation
        stoleMeta={stoleMeta}
        previewImage={previewImage}
        setZoomImage={setZoomImage}
        stolePreview={stolePreview}
        activeIndex={activeIndex}
        selectedTemplate={selectedTemplate}
        colorList={colorList}
        zoomImage={zoomImage}
        altImage={altImage}
        setActiveIndex={setActiveIndex}
        setPreviewImage={setPreviewImage}
        steps={steps}
        currentStep={currentStep}
        headerText={headerText}
        selectedStage={selectedStage}
        selectImage={selectImage}
        stoleImagePath={stoleImagePath}
        assetGroups={assetGroups}
        updateSelectedTemplate={updateSelectedTemplate}
        brandingTab={brandingTab}
        setBrandingTab={setBrandingTab}
        getBrandingTabName={getBrandingTabName}
        setLoading={setLoading}
        selectedZone={selectedZone}
        zoneAssets={zoneAssets}
        updateZoneData={updateZoneData}
        getZoneTabName={getZoneTabName}
        checkBoxValue={checkBoxValue}
        setSelectedStage={setSelectedStage}
        getRoPayload={getRoPayload}
        stoleType={stoleType}
        saveDesignFromModalShow={saveDesignFromModalShow}
        buttonText={buttonText}
        next={next}
        stolePrice={stolePrice}
        selectedImage={selectedImage}
        visited={visited}
        fontList={fontList}
				getFontList={getFontList}
				zoneImagePath={zoneImagePath}
				setZoneImagePath={setZoneImagePath}
				zoneTextStatus={zoneTextStatus}
				setZoneTextStaus={setZoneTextStaus}
        /> :
        <DesktopHome
          stoleMeta={stoleMeta}
          previewImage={previewImage}
          setZoomImage={setZoomImage}
          stolePreview={stolePreview}
          activeIndex={activeIndex}
          selectedTemplate={selectedTemplate}
          colorList={colorList}
          zoomImage={zoomImage}
          altImage={altImage}
          setActiveIndex={setActiveIndex}
          setPreviewImage={setPreviewImage}
          steps={steps}
          currentStep={currentStep}
          headerText={headerText}
          selectedStage={selectedStage}
          selectImage={selectImage}
          stoleImagePath={stoleImagePath}
          assetGroups={assetGroups}
          updateSelectedTemplate={updateSelectedTemplate}
          brandingTab={brandingTab}
          setBrandingTab={setBrandingTab}
          getBrandingTabName={getBrandingTabName}
          setLoading={setLoading}
          selectedZone={selectedZone}
          zoneAssets={zoneAssets}
          updateZoneData={updateZoneData}
          getZoneTabName={getZoneTabName}
          checkBoxValue={checkBoxValue}
          setSelectedStage={setSelectedStage}
          getRoPayload={getRoPayload}
          stoleType={stoleType}
          saveDesignFromModalShow={saveDesignFromModalShow}
          buttonText={buttonText}
          next={next}
          stolePrice={stolePrice}
          selectedImage={selectedImage}
          fontList={fontList}
					getFontList={getFontList}
					zoneImagePath={zoneImagePath}
					setZoneImagePath={setZoneImagePath}
					zoneTextStatus={zoneTextStatus}
					setZoneTextStaus={setZoneTextStaus}
        />
      }
			<SaveDesignModal
				id='saveDesignModal'
				show={modalShow}
				onHide={() => saveDesignFromModalShow(false)}
				savedesign={saveDesign}
				stolemeta={stoleMeta}
			/>
			<ThankyouModal
				id='thankyouModal'
				show={thankyomodalShow}
				onHide={() => setThankyomodalShow(false)}
				stolemeta={stoleMeta}
			/>
      <InfoDesignModal
        id="infoDesignModal"
        show={infoDesignModalShow}
        onHide={() => setinfoDesignModalShow(false)}
        stolemeta={stoleMeta}
      />
			<Modal show={showConfirmModal} centered backdrop='static' className='confirm-modal'>
				<Modal.Header closeButton	onClick={() => setShowConfirmModal(false)}>
					{stoleMeta && stoleMeta.confirmTextModal && stoleMeta.confirmTextModal.header}
				</Modal.Header>
				<Modal.Body>
					<p>{stoleMeta && stoleMeta.confirmTextModal && stoleMeta.confirmTextModal.info}</p>
				</Modal.Body>
			</Modal>
		</>
	);
}
export default Home;
